import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DataCollectionApi,
  FiscalCodeRequest,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitFiscalCodeAction = createAsyncThunk<
  FiscalCodeRequest,
  FiscalCodeRequest,
  ThunkApi
>("submitFiscalCode", async (fiscalCodeData, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addFiscalCode(fiscalCodeData);

    return fiscalCodeData;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio codice fiscale",
      description:
        "Non siamo riusciti a salvare il tuo codice fiscale.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
